import React from "react";

const PersonalInfo = () => {
  return (
    <div className="space-y-4 pt-4 m-[2%]">
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="p-6 border-b">
          <h2 className="text-xl font-semibold">Informações Pessoais</h2>
          <p className="text-sm text-gray-500">
            Atualize suas informações pessoais
          </p>
        </div>

        <div className="p-6 space-y-6">
          {/* Seção do Avatar */}
          {/* <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
            <div className="relative h-20 w-20 rounded-full bg-gray-200 flex items-center justify-center">
              <img
                src=""
                alt="Foto do perfil"
                className="w-full h-full object-contain"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
            </div>
            <button className="px-4 py-2 text-sm font-medium border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
              Alterar foto
            </button>
          </div> */}

          {/* Formulário */}
          <div className="grid gap-4 md:grid-cols-2">
            {/* Nome Completo */}
            <div className="space-y-2">
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700">
                Nome Completo
              </label>
              <input
                id="name"
                type="text"
                defaultValue="João da Silva"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border"
              />
            </div>

            {/* E-mail */}
            <div className="space-y-2">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700">
                E-mail
              </label>
              <input
                id="email"
                type="email"
                defaultValue="joao.silva@exemplo.com"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border"
              />
            </div>

            {/* Telefone */}
            <div className="space-y-2">
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700">
                Telefone
              </label>
              <input
                id="phone"
                type="tel"
                defaultValue="(11) 98765-4321"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border"
              />
            </div>

            {/* CPF */}
            <div className="space-y-2">
              <label
                htmlFor="cpf"
                className="block text-sm font-medium text-gray-700">
                CPF
              </label>
              <input
                id="cpf"
                type="text"
                defaultValue="123.456.789-00"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border"
              />
            </div>

            {/* Data de Nascimento */}
            <div className="space-y-2">
              <label
                htmlFor="birth"
                className="block text-sm font-medium text-gray-700">
                Data de Nascimento
              </label>
              <input
                id="birth"
                type="date"
                defaultValue="1990-01-01"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border"
              />
            </div>

            {/* Gênero */}
            <div className="space-y-2">
              <label
                htmlFor="gender"
                className="block text-sm font-medium text-gray-700">
                Gênero
              </label>
              <select
                id="gender"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm p-2 border bg-white">
                <option value="male">Masculino</option>
                <option value="female">Feminino</option>
                <option value="other">Outro</option>
                <option value="prefer-not-to-say">Prefiro não informar</option>
              </select>
            </div>
          </div>

          {/* Botão de Salvar */}
          <div className="flex justify-end">
            <button className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors">
              Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
